import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Grid from '@material-ui/core/Grid';
import { useStyles } from './TakisSkeleton.styles';
import TakisDivider from '../TakisDivider'

const TakisGridSkeleton = () => {
    const classes = useStyles();
      return (
        <>
          <div className={`${classes.takisGrid}`}>
            <Grid container justifyContent="center">
                <Grid className={`${classes.takisGridItemContainer}`} item xs={12} md={6} lg={4}><Skeleton className={classes.grid_item}/></Grid>
                <Grid className={`${classes.takisGridItemContainer}`} item xs={12} md={6} lg={4}><Skeleton className={classes.grid_item}/></Grid>
                <Grid className={`${classes.takisGridItemContainer}`} item xs={12} md={6} lg={4}><Skeleton className={classes.grid_item}/></Grid>
                <Grid className={`${classes.takisGridItemContainer}`} item xs={12} md={6} lg={4}><Skeleton className={classes.grid_item}/></Grid>
            </Grid>
          </div>
          <TakisDivider
            marginModifier={`${classes.gridDividerMargin}`}
            backgroundColor="gridPurple"
          />
        </>
      );
}

export default TakisGridSkeleton;
